export default "__VITE_ASSET__qNHafiDZ__"